import { object, string, number, bool, mixed } from "./";
export const serviceSchema = object().shape({
  desc: string(),
  per_unit: bool(),
  price: number().min(0.1, "BAD_SERVICE_PRICE").required(),
  unit_name: mixed().when("per_unit", {
    is: true,
    then: mixed().required(),
    otherwise: object(),
  }),
  spec: mixed().required(),
  title: mixed().required(),
});
export const serviceImportSchema = object().shape({
  price: number()
    .min(0.1, "service_import_bad_price")
    .required("service_import_price_required"),
  spec: string().required("service_import_spec_required"),
  title: string().required("service_import_title_required"),
  duration: number()
    .min(1, "service_import_bad_duration")
    .max(1380, "service_import_bad_duration"),
  row: number(),
});
